import AircraftProperty from "./Enums/AircraftProperty";

const AircraftPathConfig = {
	messageProperties: [
		AircraftProperty.TIMESTAMP,
		AircraftProperty.ICAO_ADDRESS,
		AircraftProperty.REGISTRATION,
		AircraftProperty.ALTITUDE,
		AircraftProperty.COURSE
	],
	pointProperties: {
		[AircraftProperty.ALTITUDE]: AircraftProperty.ALTITUDE,
		iconImage: (stop) => {
			return (typeof stop.properties[AircraftProperty.COURSE] !== "undefined") ? "path-triangle-isosceles" : "dot-11";
		}
	},
	pointLiveGetterProperties: {
		[AircraftProperty.REGISTRATION]: AircraftProperty.REGISTRATION,
		[AircraftProperty.FLIGHT_NUMBER]: AircraftProperty.FLIGHT_NUMBER,
		[AircraftProperty.FLIGHT_OPERATOR]: AircraftProperty.FLIGHT_OPERATOR,
		[AircraftProperty.ICAO_ADDRESS]: AircraftProperty.ICAO_ADDRESS
	},
	historicOrder: 1
};
export default AircraftPathConfig;
